import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedUserSelector($companyId: ID!, $id: ID) {
    users(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        displayName
        email
        crew
      }
    }
  }
`

export const Query = gql`
  query UserSelector(
    $companyId: ID!,
    $filters: UserFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    users(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        displayName
        email
        crew
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
